import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { isAfter, isBefore, isEqual } from 'date-fns';

export type Comparison = 'equal' | 'larger' | 'largerOrEqual' | 'smaller' | 'smallerOrEqual';

/** Creates a validator which compares the given control to another control with a comparison type in case both controls are filled in.
    The error key is the comparison type.
 */
export function createComparisonValidator(otherControl: AbstractControl, comparison: Comparison): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const otherValue = otherControl.value;

        if (control.value && otherValue) {
            switch (comparison) {
                case 'equal': {
                    if (control.value != otherValue) return { equal: true };
                    break;
                }
                case 'larger': {
                    if (control.value <= otherValue) return { larger: true };
                    break;
                }
                case 'largerOrEqual': {
                    if (control.value < otherValue) return { largerOrEqual: true };
                    break;
                }

                case 'smaller': {
                    if (control.value >= otherValue) return { smaller: true };
                    break;
                }
                case 'smallerOrEqual': {
                    if (control.value > otherValue) return { smallerOrEqual: true };
                    break;
                }
                default:
                    return null;
            }
        }

        return null;
    };
}

/** @experimental Creates a validator which compares the given date control to another date control with a comparison type in case both controls are filled in.
    Date-fns is used internally.
    The error key is the comparison type.
 */
export function createDateComparisonValidator(otherControl: AbstractControl<Date>, comparison: Comparison): ValidatorFn {
    return (control: AbstractControl<Date>): ValidationErrors | null => {
        const otherValue = otherControl?.value;

        if (control?.value && otherValue) {
            switch (comparison) {
                case 'equal': {
                    if (!isEqual(control.value, otherValue)) return { equal: true };
                    break;
                }
                case 'larger': {
                    if (!isAfter(control.value, otherValue)) return { larger: true };
                    break;
                }
                case 'largerOrEqual': {
                    if (isBefore(control.value, otherValue)) return { largerOrEqual: true };
                    break;
                }
                case 'smaller': {
                    if (!isBefore(control.value, otherValue)) return { smaller: true };
                    break;
                }
                case 'smallerOrEqual': {
                    if (isAfter(control.value, otherValue)) return { smallerOrEqual: true };
                    break;
                }
                default:
                    return null;
            }
        }

        return null;
    };
}
